import { render, staticRenderFns } from "./NhapDienNuoc.vue?vue&type=template&id=54276e42&"
import script from "./NhapDienNuoc.vue?vue&type=script&lang=js&"
export * from "./NhapDienNuoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports